<div class="content">
  <div class="modal-body p-0 font-12 ps-lg-4 pe-lg-4 ps-xl-4 pe-xl-4 font-12 font-lg-13 font-xl-13">
    <div class="invoiceDueContainer deduction-invoice-block" [id]="invoice.docNo">

      <!-- Invoice header metadata -->
      <div class="deduction-invoice-header">
        <div class="row mb-1">
          <div class="col-6">
            <span class="meta-label">{{'LABELS.DOC_NO' | translate }}</span>
            <span class="meta-value">{{invoice.docNo}}</span>
          </div>
          <div class="col-6 text-end">
            <span class="meta-label">{{ 'LABELS.AMOUNT' | translate }}</span>
            <span class="meta-value meta-strong">{{invoice.formattedAmount}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <span class="meta-label">{{'LABELS.DATE' | translate}}</span>
            <span class="meta-value">{{invoice.invoiceDate}}</span>
          </div>
          <div class="col-6 text-end">
            <span class="meta-label">{{ 'LABELS.DUE' | translate}}</span>
            <span class="meta-value">{{invoice.invDueDate}}</span>
          </div>
        </div>
      </div>

      <!-- Deductions section -->
      <div class="deduction-section" *ngIf="invoice.enablePartialPay && payData.partialPayReasons && payData.partialPayReasons.length">
        <div class="deduction-section-label">{{ 'LABELS.DEDUCTIONS' | translateWithDefault : 'Deductions' }}</div>

        <!-- Committed deduction cards (above the entry row) -->
        <div class="deduction-card" *ngFor="let deduction of invoice.deductions; let i = index;">
          <div class="deduction-card-row">
            <div class="deduction-reason" [title]="deduction.reason">{{deduction.reason}}</div>
            <div class="deduction-amount">{{deduction.amt}}</div>
            <button type="button" class="deduction-remove-btn" *ngIf="!deduction.mandatory"
              [title]="'LABELS.REMOVE_DEDUCTION' | translateWithDefault : 'Remove deduction'"
              (click)="removeDeduction(invoice, i, invoice.deductions)">
              <i class="fa fa-trash-o" aria-hidden="true"></i>
            </button>
            <span class="deduction-remove-spacer" *ngIf="deduction.mandatory"></span>
          </div>
          <div class="deduction-attachment">
            <input type="file" hidden #deductionDocInput
              accept="image/*,.pdf,.csv,.xls,.xlsx,.doc,.docx,.rtf"
              (change)="onSupportingDocSelected(deduction, $event)">
            <span class="doc-chip" *ngIf="deduction.supportingDocName"
              [title]="deduction.supportingDocName" (click)="deductionDocInput.click()">
              <i class="fa fa-paperclip" aria-hidden="true"></i>
              <span class="doc-chip-name">{{deduction.supportingDocName}}</span>
              <button type="button" class="doc-chip-remove"
                [title]="'LABELS.REMOVE_SUPPORTING_DOC' | translateWithDefault : 'Remove Supporting Document'"
                (click)="$event.stopPropagation(); clearSupportingDoc(deduction, deductionDocInput)">&times;</button>
            </span>
            <a class="attach-doc-link" *ngIf="!deduction.supportingDocName" (click)="deductionDocInput.click()">
              <i class="fa fa-paperclip me-1" aria-hidden="true"></i>{{ 'LABELS.ATTACH_SUPPORTING_DOCUMENT' | translateWithDefault : 'Attach supporting document' }}
            </a>
          </div>
        </div>

        <!-- Entry row (below the committed cards) -->
        <div class="deduction-entry">
          <div class="deduction-card-row">
            <select class="form-select deduction-reason-select font-12" [(ngModel)]="invoice.deductionModel.reason"
              name="deductionModelReason_{{invoice.docNo}}"
              (ngModelChange)="validateDeductionModel(invoice, invoice.deductionModel)">
              <option value="">{{ 'LABELS.SELECT_PARTIAL_PAY_REASON' | translate}}</option>
              <option *ngFor="let reason of payData.payReasons.partialPayReasons" [ngValue]="reason">{{reason.reason}}</option>
            </select>
            <input type="tel" class="form-control deduction-amount-input" appNumberOnly numericType="decimal"
              autocomplete="off" placeholder="{{ 'LABELS.ENTER_DEDUCTION_AMT' | translate}}"
              [(ngModel)]="invoice.deductionModel.amt"
              (ngModelChange)="validateDeductionModel(invoice, invoice.deductionModel)"
              name="deductionModelAmt_{{invoice.docNo}}" #deductionAmountInput>
            <button type="button" class="deduction-add-btn"
              (click)="addDeduction(invoice, invoice.deductionModel, invoice.deductions)"
              [disabled]="!invoice.deductionModel.isValid">
              <i class="fa fa-plus-circle" aria-hidden="true"></i>
            </button>
          </div>
          <div class="deduction-attachment">
            <input type="file" hidden #deductionEntryDocInput
              accept="image/*,.pdf,.csv,.xls,.xlsx,.doc,.docx,.rtf"
              (change)="onSupportingDocSelected(invoice.deductionModel, $event)">
            <span class="doc-chip" *ngIf="invoice.deductionModel.supportingDocName"
              [title]="invoice.deductionModel.supportingDocName" (click)="deductionEntryDocInput.click()">
              <i class="fa fa-paperclip" aria-hidden="true"></i>
              <span class="doc-chip-name">{{invoice.deductionModel.supportingDocName}}</span>
              <button type="button" class="doc-chip-remove"
                [title]="'LABELS.REMOVE_SUPPORTING_DOC' | translateWithDefault : 'Remove Supporting Document'"
                (click)="$event.stopPropagation(); clearSupportingDoc(invoice.deductionModel, deductionEntryDocInput)">&times;</button>
            </span>
            <a class="attach-doc-link" *ngIf="!invoice.deductionModel.supportingDocName" (click)="deductionEntryDocInput.click()">
              <i class="fa fa-paperclip me-1" aria-hidden="true"></i>{{ 'LABELS.ATTACH_SUPPORTING_DOCUMENT' | translateWithDefault : 'Attach supporting document' }}
            </a>
          </div>
          <div class="deduction-error" *ngIf="invoice.deductionModel.invalidMsg">{{invoice.deductionModel.invalidMsg}}</div>
        </div>
      </div>

      <!-- Withholding tax section -->
      <div class="deduction-section" *ngIf="payData.whtReasons && payData.whtReasons.length && invoice.enableWHT">
        <div class="deduction-section-label">{{ 'LABELS.WITHHOLDING_TAX' | translateWithDefault : 'Withholding tax' }}</div>

        <!-- Committed WHT cards (above the entry row) -->
        <div class="deduction-card" *ngFor="let deduction of invoice.whtDeductions; let i = index;">
          <div class="deduction-card-row">
            <div class="deduction-reason" [title]="deduction.reason">{{deduction.reason}} {{deduction.mandatory ? '***' : ''}}</div>
            <div class="deduction-amount">{{deduction.amt}}</div>
            <button type="button" class="deduction-remove-btn" *ngIf="!deduction.mandatory"
              [title]="'LABELS.REMOVE_DEDUCTION' | translateWithDefault : 'Remove deduction'"
              (click)="removeDeduction(invoice, i, invoice.whtDeductions)">
              <i class="fa fa-trash-o" aria-hidden="true"></i>
            </button>
            <span class="deduction-remove-spacer" *ngIf="deduction.mandatory"></span>
          </div>
          <div class="deduction-attachment">
            <input type="file" hidden #whtDocInput
              accept="image/*,.pdf,.csv,.xls,.xlsx,.doc,.docx,.rtf"
              (change)="onSupportingDocSelected(deduction, $event)">
            <span class="doc-chip" *ngIf="deduction.supportingDocName"
              [title]="deduction.supportingDocName" (click)="whtDocInput.click()">
              <i class="fa fa-paperclip" aria-hidden="true"></i>
              <span class="doc-chip-name">{{deduction.supportingDocName}}</span>
              <button type="button" class="doc-chip-remove"
                [title]="'LABELS.REMOVE_SUPPORTING_DOC' | translateWithDefault : 'Remove Supporting Document'"
                (click)="$event.stopPropagation(); clearSupportingDoc(deduction, whtDocInput)">&times;</button>
            </span>
            <a class="attach-doc-link" *ngIf="!deduction.supportingDocName" (click)="whtDocInput.click()">
              <i class="fa fa-paperclip me-1" aria-hidden="true"></i>{{ 'LABELS.ATTACH_SUPPORTING_DOCUMENT' | translateWithDefault : 'Attach supporting document' }}
            </a>
          </div>
        </div>

        <!-- WHT entry row -->
        <div class="deduction-entry">
          <div class="deduction-card-row">
            <select class="form-select deduction-reason-select font-12" [(ngModel)]="invoice.whtDeductionModel.reason"
              name="whtDeductionModelReason_{{invoice.docNo}}"
              (ngModelChange)="getDeductionAmountForTDS(invoice, invoice.whtDeductionModel)">
              <option value="">{{ 'LABELS.SELECT_WHT_REASON' | translate}}</option>
              <option *ngFor="let reason of payData.whtReasons" [ngValue]="reason">{{reason.reason}}</option>
            </select>
            <label class="deduction-amount-input readonly-amt" *ngIf="invoice.whtDeductionModel.isreadonly">{{invoice.whtDeductionModel.amt}}</label>
            <input *ngIf="!invoice.whtDeductionModel.isreadonly" type="tel" class="form-control deduction-amount-input"
              appNumberOnly numericType="decimal" autocomplete="off"
              placeholder="{{'LABELS.ENTER_WHT_AMOUNT' | translate}}"
              [(ngModel)]="invoice.whtDeductionModel.amt"
              (ngModelChange)="validateDeductionModel(invoice, invoice.whtDeductionModel)"
              name="whtdeductionModelAmt_{{invoice.IN}}" #whtAmountInput>
            <button type="button" class="deduction-add-btn"
              (click)="addDeduction(invoice, invoice.whtDeductionModel, invoice.whtDeductions)"
              [disabled]="!invoice.whtDeductionModel.isValid">
              <i class="fa fa-plus-circle" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="row mb-2 cashDicountContainer" *ngIf="payData.invCDAmts && payData.invCDAmts[invoice.TI] > 0">
        <div class="col-12">
          <span class="cashDiscount">
            <strong> {{ 'LABELS.APPLICABLE_CD' | translate}}: {{payData.invCDAmts[invoice.TI] | inrdisplay}}</strong>
          </span>
        </div>
      </div>
      <div class="row mt-2" *ngIf="invoice.withholdTaxAmount">
        <div class="col-12">
          <label class="deduction-wht-note">
            {{ 'LABELS.PLEASE_NOTE_THAT_WITHHOLDING_AMOUNT' | translate}} {{invoice.withholdTaxAmount | inrdisplay}} {{ 'LABELS.FOR_THIS_INVOICE' | translate}}
          </label>
        </div>
      </div>

    </div>
  </div>
</div>
